import { render } from "./testimonials.vue?vue&type=template&id=05a01f9e&scoped=true"
import script from "./testimonials.vue?vue&type=script&lang=js"
export * from "./testimonials.vue?vue&type=script&lang=js"

import "./testimonials.vue?vue&type=style&index=0&id=05a01f9e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05a01f9e"]])

export default __exports__